<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Имя" v-model="data.firstName" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Телефон" v-model="data.phone"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-subheader class="pl-0">Кол-го гостей</v-subheader>
                            <v-slider
                                    max="30"
                                    min="1"
                                    v-model="data.countPerson"
                                    thumb-label="always"
                            ></v-slider>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <div class="d-flex justify-center">
                <v-spacer></v-spacer>
                <v-col cols="6">
                    <v-btn color="error"  block @click="resetTables">Закрыть</v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn color="blue darken-1" :loading='saving' block  @click="reservation">Создать</v-btn>
                </v-col>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "FastCreateBooking",
        mounted() {
            bus.$on('createFastBooking', (payload) => {
                this.data.tables = payload.tables;
                this.restaurantId = payload.restaurantId;
                this.reservations = payload.allTables
                this.dialog = true;
            })
        },
        data() {
            return {
                reservations : {},
                restaurantId: null,
                saving: false,
                data: {
                    firstName: '',
                    phone: '',
                    countPerson: 4,
                    tables: []
                },
                dialog: false
            }
        },
        methods:{
            resetTables(){
                this.dialog = false
            },
            reservation() {
                if (this.saving) {
                    return
                }

                this.saving = true;

                let data = {
                    name: this.data.firstName,
                    phone: this.data.phone,
                    countPerson: this.data.countPerson,
                    table: this.data.tables
                }

                let url = '/reservation/' + this.restaurantId + '/reservation-fast';

                axios.post(url, data)
                    .then(() => {
                        this.saving = false;
                        this.dialog = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>
